 <template>
  <Dashboard>
    <template v-slot:title>
      <h2>{{$t("campaigns.title")}}</h2>
    </template>
    <template v-slot:buttonRight>
      <div class="row onRight">
        <router-link
          v-if="$store.getters.USERPROFILE['campaign-administration']&&viewtype"
          :to="{name: 'createCampaign'}"
        >
          <button>
            <i class="fas fa-plus"></i>
            {{$t('button.createCoupon')}}
          </button>
        </router-link>
      </div>
    </template>
    <template v-slot:tab v-if="campaigns.length > 0">
      <thead>
        <tr class="trHead">
          <th v-for="item in tab" :key="item.title" class="accentuate">
            <div class="row">
              {{item.title}}
              <div
                class="column sort"
                v-if="item.title ==  $t('campaigns.campaignName') || item.title ==  $t('campaigns.expiration') "
              >
                <i
                  v-if="sort.order == -1  && item.sort==sort.type "
                  class="fas fa-sort-up up blueColor"
                  @click="(sort.type = item.sort) && (sort.order = 1)"
                ></i>
                <i
                  v-else-if="sort.order == 1 && item.sort==sort.type"
                  class="fas fa-sort-down down blueColor"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
                <i
                  v-else-if="sort.order == 1|| item.sort!=sort.type"
                  class="fas fa-sort-down down"
                  @click="(sort.type = item.sort) && (sort.order = -1)"
                ></i>
              </div>
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="data in sortCampaigns" :key="data.title">
          <td>{{data.name}}</td>
          <td v-if="data['campaign-type-global']">{{data['global-code']}}</td>
          <td v-else>{{data['max-number-of-coupons'] +"&nbsp;"+ $t('campaigns.coupons')}}</td>

          <td>
            <!-- diplay conditions -->
            <span v-for="(discount, index) in data['list-of-discounts']" :key="discount.title">
              <span v-if="index!=0">&nbsp;, &nbsp;&nbsp;</span>
              <span
                v-if="discount['discount-value']==0"
                class="chipValue void"
              >{{$t('discountValue.noDiscount')}}</span>
              <span
                v-else-if="discount['discount-value']==100&&discount['discount-type']==0"
                class="chipValue red"
              >{{$t('discountValue.free')}}</span>
              <span
                v-else-if="discount['discount-type']==0"
                class="chipValue orange"
              >-{{discount['discount-value']}} %</span>
              <span
                v-else
                class="chipValue lightorange"
              >-{{(discount['discount-value']/100).toFixed(2)}} {{convertCurrencyToSymbol(discount['discount-currency'])}}</span>
              <span>{{' ' +discount["product-name"]}}</span>
            </span>
            <span class="comments" v-if="data['number-of-discounts']>1"> + {{data['number-of-discounts']-1}} {{$t('campaigns.otherConditions')}}</span>
          </td>
          <td>{{data['number-of-used-coupons']}}/{{data['max-number-of-coupons']}}</td>
          <td
            v-if="data['expiration-date']"
          >{{moment(data['expiration-date']).format(`DD/MM/YYYY ${$t('dateManagement.at')} HH[${$t('dateManagement.hourSeparator')}]mm`)}}</td>
          <td v-else class="comments">{{$t('dateManagement.noEndDate')}}</td>
          <td>
            <p class="chip grey" v-if="data['status'] === 0">{{$t('campaignStatus.draft')}}</p>
            <p class="chip green" v-if="data['status'] === 1">{{$t('campaignStatus.active')}}</p>
            <p class="chip greyBold" v-if="data['status'] === 2">{{$t('campaignStatus.archived')}}</p>
            <p class="chip black" v-if="data['status'] === 3">{{$t('campaignStatus.closed')}}</p>
          </td>
          <td v-bind:class="{ 'bubbleParentCampaign' : data.status ==0}">
            <button
              @click="$router.push({name: 'detailUniqueCampaign', params: { id: data.id}})"
              v-if="data.status !=0 && data['campaign-type-global']"
              class="outline"
            >
              <i class="fas fa-plus"></i>
              {{$t('button.details')}}
            </button>
            <button
              @click="$router.push({name: 'detailGroupCampaign', params: { id: data.id}})"
              v-if="data.status !=0 && !data['campaign-type-global']"
              class="outline"
            >
              <i class="fas fa-plus"></i>
              {{$t('button.details')}}
            </button>
            <button
              ref="bubble"
              class="outline" 
              v-if="data.status ==0 && pageRights.modifyCampaign"
              @click="bubbleClick(data.id)"
            >
              <img ref="bubble" class="pastille" src="@/assets/images/pastille.png" alt="pastille">
            </button>
            <div class="bubble" v-if="bubbleAction(data.id)">
              <a
                @click="$router.push({name: 'updateCampaign', params: { id: data.id}})"
              >{{$t('button.modify')}}</a>
              <a
                v-if="!data['archived']"
                @click="archive(data,2)"
                class="redText"
              >{{$t('campaigns.confirmArchiveTitle')}}</a>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
    <template v-slot:tab v-else-if="viewtype && isCampaignsretrieved">
      <NoCampaign></NoCampaign>
    </template>
    <template v-slot:tab v-else-if="!viewtype && isCampaignsretrieved">
      <NoArchivedCampaign></NoArchivedCampaign>
    </template>
  </Dashboard>
</template>

<script>
import Dashboard from "../layout/Dashboard";
import NoCampaign from "./NoCampaign";
import Campaigns from "@/services/Campaigns";
import NoArchivedCampaign from "./NoArchivedCampaign";
import bubble from "@/mixins/bubble";
import Discounts from "@/services/Discounts";
import generalMethods from "@/mixins/generalMethods";
import axios from "axios";
import compare from "@/mixins/compare";
import getCampaignDetails from "@/mixins/getCampaignDetails";
export default {
  mixins: [bubble, generalMethods, compare,getCampaignDetails],
  components: {
    NoCampaign,
    NoArchivedCampaign,
    Dashboard
  },
  data() {
    return {
      showExport: false,
      campaigns: [],
      viewtype: false,
      isCampaignsretrieved: false,
      sort: {
        order: 1,
        type: "name"
      }
    };
  },
  computed: {
    // récupération du chemin
    getFullPath: {
      get: function() {
        return this.$route.path;
      }
    },
    sortCampaigns: function() {
      const campaigns = this.campaigns;
      return campaigns.sort(this.compare);
    },
    tab() {
      return [
        { title: this.$t("campaigns.campaignName"), sort: "name" },
        { title: this.$t("campaigns.code") },
        { title: this.$t("campaigns.conditions") },
        { title: this.$t("campaigns.use") },
        { title: this.$t("campaigns.expiration"), sort: "expiration-date" },
        { title: this.$t("campaignStatus.status"), sort: "status" }
      ];
    }
  },
  mounted() {
    this.getCampaigns();
    this.modifyViewtype();
  },

  watch: {
    //si modifs dans les paramètres de la page
    getFullPath: {
      handler() {
        this.modifyViewtype();
        this.getCampaigns();
      }
    }
  },
  methods: {
    archive(data, state) {
      Campaigns.partialUpdate(data.id, { status: state }).then(res => {
        if (res.status == 204) {
          this.getCampaigns();
        } else {
          console.log("Error: Impossible to archive");
        }
      });
    },
    modifyViewtype() {
      if (this.$route.params.campaignType == "archived") this.viewtype = false;
      else this.viewtype = true;
    },
    getCampaigns() {
      this.isCampaignsretrieved = false;
      Campaigns.get().then(res => {
        if (res.status == 200) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i]["number-of-used-coupons"] == null)
              res.data[i]["number-of-used-coupons"] = "0";
            else
              res.data[i]["number-of-used-coupons"] = res.data[i][
                "number-of-used-coupons"
              ].toLocaleString("fr");

            if (res.data[i]["max-number-of-coupons"] == null)
              res.data[i]["max-number-of-coupons"] = "0";
            else
              res.data[i]["max-number-of-coupons"] = res.data[i][
                "max-number-of-coupons"
              ].toLocaleString("fr");
          }
          var localCampaigns = [];
          if (this.viewtype)
            // campagnes actives
            localCampaigns = res.data.filter(
              x => x["status"] == 1 || x["status"] == 0
            );
          else
            localCampaigns = res.data.filter(
              x => x["status"] == 2 || x["status"] == 3
            );
          //get discount for each campaign
          var promises = [];
          for (var k = 0; k < localCampaigns.length; k++) {
            promises.push(Discounts.getByCampaignId(localCampaigns[k].id));
          }
          var discountByCampaign = [];
          axios.all(promises).then(results => {
            results.forEach(function(response) {
              if (response.status == 200)
                discountByCampaign.push(response.data);
              else discountByCampaign.push({});
            });

            for (var j = 0; j < localCampaigns.length; j++) {
              localCampaigns[j]["number-of-discounts"] =
                discountByCampaign[j].length;
              localCampaigns[j]["list-of-discounts"] = discountByCampaign[
                j
              ].splice(0, 1);
            }
            this.campaigns = localCampaigns;
            this.isCampaignsretrieved = true;
          });
        } else this.isCampaignsretrieved = true;

          this.checkUserRights();
      });
    }
  }
};
</script>
 <style scoped>
.bubbleParentCampaign {
  position: relative;
  text-align: center;
}
</style>